import { render, staticRenderFns } from "./App.vue?vue&type=template&id=fc6f8944&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=fc6f8944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6f8944",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/App.vue
// module id = null
// module chunks = 